// extracted by mini-css-extract-plugin
export default {"filterContainer":"SortFilter_filterContainer__PaG05","title":"SortFilter_title__VUUrV","padl6":"SortFilter_padl6__1PHTF"};